export const HR_FORM_NOTE_TAG = 'hr-form-v1';

export const buildHrFormNote = ({
  kind,
  mode,
  notes,
  extra,
}: {
  kind: string;
  mode?: string;
  notes?: string;
  extra?: any;
}) => {
  return JSON.stringify({
    _tag: HR_FORM_NOTE_TAG,
    _version: 1,
    kind,
    mode,
    notes: notes || '',
    extra: extra || {},
    savedAt: new Date().toISOString(),
  });
};

export const parseHrFormNote = (note: any) => {
  if (!note || typeof note !== 'string') {
    return null;
  }
  try {
    const parsed = JSON.parse(note);
    if (parsed?._tag === HR_FORM_NOTE_TAG) {
      return parsed;
    }
    return null;
  } catch (error) {
    return null;
  }
};
